import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import styled from "styled-components";
import { CheckboxToggle, FormSectionContent } from "@components";
import { NewModuleSetting, UpdatedModuleSetting } from "@models";
import { ConfigModuleSetting } from "../configuration/types";
import { Alert } from "react-bootstrap";
import { Currency } from "@util";

type Props = {
	moduleSetting: NewModuleSetting | UpdatedModuleSetting;
	isNewModuleSetting: boolean;
};

type FormValues = Pick<ConfigModuleSetting, "useBalanceAccount">;

export default function BalanceAccountConfiguration(props: Props) {
	const { control, setValue, watch } = useFormContext<FormValues>();
	const { moduleSetting, isNewModuleSetting } = props;
	const moduleSettingAmount = Currency.format(
		moduleSetting.amounts[0].maxAmountMonth,
		{ hideZeroDecimals: true }
	);

	const ENABLE_BALANCE_ACCOUNT_INFO = `Das monatliche Budget wird jeden Monat mit bis zu ${moduleSettingAmount} mit dem Guthaben vom zugehörigen Guthabenkonto aufgeladen.`;

	const DISABLE_BALANCE_ACCOUNT_INFO = (
		<StyledText>
			Das monatliche Budget wird jeden Monat mit einem festen Betrag von{" "}
			{moduleSettingAmount} aufgeladen und <strong>nicht</strong> vom
			Guthabenkonto abgebucht
		</StyledText>
	);

	const getInfoMessage = () => {
		const useBalanceAccount = watch("useBalanceAccount");
		return useBalanceAccount
			? ENABLE_BALANCE_ACCOUNT_INFO
			: DISABLE_BALANCE_ACCOUNT_INFO;
	};

	return (
		<>
			<BalanceAccountContainer>
				<Controller
					name="useBalanceAccount"
					defaultValue={moduleSetting.useBalanceAccount}
					control={control}
					render={({ field }) => (
						<CheckboxToggle
							{...field}
							value={field.value.toString()}
							label={
								isNewModuleSetting
									? "Guthabenkonto anlegen"
									: "Guthabenkonto verwenden"
							}
							checked={field.value}
							onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
								setValue("useBalanceAccount", e.target.checked, {
									shouldDirty: true,
									shouldValidate: true,
								});
							}}
						/>
					)}
				/>
			</BalanceAccountContainer>
			<AlertMessageContainer>
				<Alert variant="info">{getInfoMessage()}</Alert>
			</AlertMessageContainer>
		</>
	);
}

const BalanceAccountContainer = styled(FormSectionContent)`
	grid-column: span 3;
`;

const AlertMessageContainer = styled(FormSectionContent)`
	grid-column: span 3;
	margin-top: 8px;
`;

const StyledText = styled.p`
	margin-bottom: 0px;
`;
